module.exports = __webpack_public_path__ + "static/media/protect-2.b711be48.png";